import React from 'react';
import { ContentZonesService, LocaleService } from '@sm360/widget-commons-core-services';
import { REDIRECTIONS } from '@sm360/widget-commons-general';

import 'login/components/Library/PrivacyPolicy/PrivacyPolicy.scss';

const czGroup = 'widget.login.privacypolicy';

const PrivacyPolicy = () => {
    const linkText = ContentZonesService.getContentZone(czGroup, 'linktext').getValue();
    const locale = LocaleService.getSimpleLocale();
    const href = REDIRECTIONS[locale].privacyPolicy;

    return (
        <div className="form-disclaimer privacy-policy">
            <a href={href} target="_blank" rel="noopener noreferrer" className="sr-link">
                {linkText}
            </a>
        </div>
    );
};

PrivacyPolicy.displayName = 'PrivacyPolicy';

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/components/Library/PrivacyPolicy/PrivacyPolicy.jsx